import(/* webpackMode: "eager" */ "/vercel/path0/src/app/videos/[id]/page.tsx");
